import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { Request, Response, rtkBaseQueryWrapper, unwrap, WithRefetchKey } from '~libs/axiosWrapper';
import { Worker } from '~weekly-planner/lib/common';
import { SimulateParams } from '~weekly-planner/lib/simulate';

export const typePrefix = 'weekly-planner-users';

interface SendSMSReq {
  id: number | string;
  message: string;
}

export const usersApi = createApi({
  reducerPath: 'weeklyPlannerUsersApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['users'],
  endpoints: (builder) => ({
    getUsers: builder.query<Worker[], Request & WithRefetchKey>({
      query: (arg) => {
        const { __refetchKey, ...params } = arg ?? {};
        return { url: '/users', method: 'GET', params };
      },
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const { __refetchKey, ...stable } = queryArgs ?? {};
        return { endpointName, ...stable };
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.__refetchKey !== previousArg?.__refetchKey;
      },
      providesTags: [{ type: 'users', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Worker[]>(payload),
    }),
    sendSMS: builder.mutation<Response<null>, SendSMSReq>({
      query: (body) => ({ url: '/users/sms', method: 'POST', body }),
    }),
    simulate: builder.mutation<Response<Worker[]>, SimulateParams>({
      query: (body) => ({ url: '/simulate', method: 'PUT', body }),
    }),
  }),
});

export const { useGetUsersQuery, useSendSMSMutation, useSimulateMutation } = usersApi;
